<!-- Backdrop -->
<div class="cd-modal-backdrop" (click)="close.emit()"></div>

<!-- Modal -->
<div class="cd-modal-wrap cd-modal-wrap--lg">
  <!-- Modal Head -->
  <div class="modal-head">
    <div>
      <div class="eyebrow">DETAIL VIEW</div>
      <h2>Student Profile</h2>
    </div>
    <button type="button" class="icon-button" (click)="close.emit()" aria-label="Close modal">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>

  <!-- ============== REAL, API-BACKED FLOW (Students directory) ============== -->
  <ng-container *ngIf="studentUserId; else legacyProfile">
    <div *ngIf="isLoadingStudent && !studentDetail" class="empty-state-text">Loading student profile…</div>

    <ng-container *ngIf="studentDetail as student">
      <!-- Header -->
      <div class="profile-hero">
        <div class="avatar large">{{ initials }}</div>
        <div class="hero-info">
          <h3 class="hero-name">{{ student.first_name }} {{ student.last_name }}</h3>
          <div class="hero-badges">
            <span class="hero-email">{{ student.email }}</span>
            <span class="hero-sep">·</span>
            <span class="hero-email">{{ student.course || '—' }}</span>
            <span class="hero-sep">·</span>
            <span class="hero-email">{{ student.year_of_passing || '—' }}</span>
            <span class="status-pill" [ngClass]="statusClass">{{ student.is_active ? 'Active' : 'Inactive' }}</span>
          </div>
        </div>
      </div>

      <!-- Tabs Header -->
      <div class="tabs-header">
        <button type="button" class="tab-button" [class.active]="activeTab === 'overview'" (click)="activeTab = 'overview'">OVERVIEW</button>
        <button type="button" class="tab-button" [class.active]="activeTab === 'applications'" (click)="activeTab = 'applications'">JOB APPLICATIONS</button>
      </div>

      <!-- Tab Content -->
      <div class="tab-body">
        <!-- OVERVIEW TAB -->
        <div *ngIf="activeTab === 'overview'" class="overview-content">
          <div class="section-block">
            <h4 class="section-title">Stats</h4>
            <div class="metrics-grid metrics-grid--4">
              <div class="metric-card"><span>Practice Mock Tests</span><strong>{{ student.stats.practice_mock_tests }}</strong></div>
              <div class="metric-card"><span>Practice interviews</span><strong>{{ student.stats.interviews_completed }}</strong></div>
              <div class="metric-card"><span>Jobs Applied</span><strong>{{ student.stats.jobs_applied }}</strong></div>
              <div class="metric-card"><span>Resume Created</span><strong>{{ student.stats.resume_created }}</strong></div>
            </div>
          </div>

          <div class="section-block">
            <h4 class="section-title">Student Information</h4>
            <div class="details-grid">
              <div class="detail-item"><span>Name</span><strong>{{ student.first_name }} {{ student.last_name }}</strong></div>
              <div class="detail-item"><span>Email</span><strong>{{ student.email }}</strong></div>
              <div class="detail-item"><span>Mobile</span><strong>{{ student.phone_number || '—' }}</strong></div>
              <div class="detail-item"><span>City</span><strong>{{ student.city || '—' }}</strong></div>
              <div class="detail-item"><span>Course / Degree</span><strong>{{ student.course || '—' }}</strong></div>
              <div class="detail-item"><span>Year of Passing</span><strong>{{ student.year_of_passing || '—' }}</strong></div>
            </div>
          </div>
        </div>

        <!-- APPLICATIONS TAB -->
        <div *ngIf="activeTab === 'applications'" class="applications-content">
          <div *ngIf="isLoadingApplications" class="empty-state-text">Loading job applications…</div>

          <div *ngIf="!isLoadingApplications && applications.length > 0" class="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Company</th><th>Job Title</th><th>Work Mode</th><th>Application Date</th><th>Status</th><th>Assessment</th><th>Interview</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let app of applications">
                  <td><strong>{{ app.company_name }}</strong></td>
                  <td>{{ app.job_title }}</td>
                  <td>{{ app.work_mode || '—' }}</td>
                  <td>{{ app.applied_at ? (app.applied_at | date: 'mediumDate') : '—' }}</td>
                  <td>
                    <span class="status-pill" [ngClass]="applicationStatusClass(app.status)">{{ app.status }}</span>
                  </td>
                  <td>
                    <span>{{ progressLabel(app.assessment) }}</span>
                    <a *ngIf="app.assessment.status === 'completed' && app.assessment.attempt_id" href="javascript:void(0)" (click)="viewAssessmentReport(app)" class="view-report-link">· View Report</a>
                  </td>
                  <td>
                    <span>{{ progressLabel(app.interview) }}</span>
                    <a *ngIf="app.interview.status === 'completed' && app.interview.session_id && app.interview.report_token" href="javascript:void(0)" (click)="viewInterviewReport(app)" class="view-report-link">· View Report</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="!isLoadingApplications && applications.length === 0" class="empty-state-text">No job applications found.</div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- ============== LEGACY MOCK FLOW (Overview / Readiness / Attention) ============== -->
  <ng-template #legacyProfile>
    <ng-container *ngIf="student">
      <div class="tabs-header">
        <button type="button" class="tab-button" [class.active]="activeTab === 'overview'" (click)="activeTab = 'overview'">OVERVIEW</button>
        <button type="button" class="tab-button" [class.active]="activeTab === 'applications'" (click)="activeTab = 'applications'">JOB APPLICATIONS</button>
      </div>

      <div class="tab-body">
        <div *ngIf="activeTab === 'overview'" class="overview-content">
          <div class="profile-hero">
            <div class="avatar large">{{ legacyInitials }}</div>
            <div class="hero-info">
              <h3 class="hero-name">{{ student.name }}</h3>
              <div class="hero-badges">
                <div class="readiness-trigger" (click)="onReadinessClick()" title="Click to view Readiness Profile">
                  <span class="readiness-prefix">Readiness:</span>
                  <span class="readiness-pill" [ngClass]="legacyReadinessClass">{{ legacyReadinessLabel }} ({{ student.score }})</span>
                </div>
                <span class="status-pill" [ngClass]="legacyStatusClass">{{ student.placementStatus }}</span>
              </div>
            </div>
          </div>

          <div class="details-grid">
            <div class="detail-item"><span>Student ID</span><strong>{{ student.id }}</strong></div>
            <div class="detail-item"><span>Email</span><strong>{{ student.email }}</strong></div>
            <div class="detail-item"><span>Department</span><strong>{{ student.department }}</strong></div>
            <div class="detail-item"><span>Year</span><strong>{{ student.year }}</strong></div>
          </div>

          <div class="section-block">
            <h4 class="section-title">Activity Summary</h4>
            <div class="metrics-grid">
              <div class="metric-card"><span>Assessments Completed</span><strong>{{ student.assessmentsCleared }}</strong></div>
              <div class="metric-card"><span>Interviews Completed</span><strong>{{ student.interviewsCleared }}</strong></div>
            </div>
          </div>

          <div class="section-block">
            <h4 class="section-title">Placement Preparation</h4>
            <div class="prep-card">
              <div class="prep-col">
                <span class="prep-label">Practice Interview</span>
                <strong class="prep-used">{{ (student.practiceInterviewCredits || 0) * 15 }} / 60 minutes used</strong>
                <span class="prep-remaining">{{ 60 - ((student.practiceInterviewCredits || 0) * 15) }} minutes remaining</span>
              </div>
              <div class="prep-col">
                <span class="prep-label">Practice Assessments</span>
                <strong class="prep-used">{{ (student.practiceAssessmentCredits || 0) * 10 }} / 1,000 questions used</strong>
                <span class="prep-remaining">{{ 1000 - ((student.practiceAssessmentCredits || 0) * 10) }} questions remaining</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="activeTab === 'applications'" class="applications-content">
          <div *ngIf="legacyStudentApplications.length > 0; else noApps" class="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Job / Role</th><th>Company</th><th>Applied On</th><th>Status</th><th>Assessment</th><th>Interview</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let app of legacyStudentApplications">
                  <ng-container *ngIf="getJob(app.jobId) as job">
                    <td><strong>{{ job.role }}</strong></td>
                    <td>{{ job.company }}</td>
                    <td>{{ job.postedDate || 'N/A' }}</td>
                    <td>
                      <span class="status-pill" [ngClass]="app.status === 'Selected' ? 'success' : app.status === 'Rejected' ? 'warning' : 'neutral'">{{ app.status }}</span>
                    </td>
                    <td>
                      <span>{{ job.status === 'Assessment Ongoing' || job.status === 'Applications Open' ? 'Ongoing' : 'Cleared' }}</span>
                      <small *ngIf="job.status !== 'Assessment Ongoing' && job.status !== 'Applications Open'" class="score-sub">Score: 85%</small>
                    </td>
                    <td>
                      <span>{{ job.status === 'Interviews Ongoing' || job.status === 'Assessment Ongoing' || job.status === 'Applications Open' ? 'Ongoing' : 'Cleared' }}</span>
                      <small *ngIf="job.status !== 'Interviews Ongoing' && job.status !== 'Assessment Ongoing' && job.status !== 'Applications Open'" class="score-sub">Score: 4/5</small>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noApps>
            <div class="empty-state-text">No job applications found.</div>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </ng-template>
</div>
